import api from '@/services/api';

export default {
  list(userId) {
    return api.get(`/users/${userId}/parent-students`);
  },
  add(userId, payload) {
    // payload: { studentId, relationshipId, isPrimary?, notes? }
    return api.post(`/users/${userId}/parent-students`, payload);
  },
  update(userId, studentId, payload) {
    // payload kann z. B. { relationshipId, isPrimary, notes } enthalten
    return api.patch(`/users/${userId}/parent-students/${studentId}`, payload);
  },
  remove(userId, studentId) {
    return api.delete(`/users/${userId}/parent-students/${studentId}`);
  },
};
